import { get } from 'lodash';
import { FLOW_TYPE, PageKeys } from 'consts';
import { Language, Translations } from 'store/state';

export function Translate(key: string, page: PageKeys, exact: boolean, language: Language, translations: Translations) {
	if (key.includes(FLOW_TYPE.RR_SU)) {
		const txt = get(translations, `${language}.${page}.${key}`);
		return typeof txt === 'string' ? txt : key;
	}
	const i = exact ? key : key.replace(/rr-/i, '').replace(/av/i, 'mv');
	return get(translations, `${language}.${page}.${i}`) || '';
}
